import { CustomTable, CustomTableProps } from '@atbay/cyber-components'
import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import { ComponentType } from 'react'

export const TableWrapper = styled('div')<{ theme?: TTheme }>`
    padding: 20px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 12px;
`

export const Cell = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 45px;
`

export const StatusCell = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
`

export const StyledFdConfigTable = styled(
    CustomTable as ComponentType<CustomTableProps>
)<{
    theme?: TTheme
}>`
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};

    table {
        overflow: hidden;
        background-color: ${({ theme }) =>
            theme.colors.semantic.backgroundSecondary};
        border-bottom: 1px solid ${({ theme }) => theme.colors.greys[200]};
        tr {
            background-color: ${({ theme }) =>
                theme.colors.semantic.backgroundSecondary};
            color: ${({ theme }) => theme.colors.greys[800]};
            height: 45px;
        }
        th {
            height: 45px;
            vertical-align: middle;
        }
    }
`
